"use client";

import { Box, type BoxProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

const DEFAULT_CONTENT_ITEM_CARD_PADDING = { base: "3", md: "4" } as const;

export type ContentItemCardProps = Omit<BoxProps, "children"> & {
  children: ReactNode;
  accentColor?: string;
  accentWidth?: string;
  selected?: boolean;
  selectedBg?: string;
  selectedBorderColor?: string;
  selectedOutlineWidth?: string;
};

export default function ContentItemCard({
  accentColor,
  accentWidth = "3",
  selected = false,
  selectedBg = "moveon.selection.bg",
  selectedBorderColor = "moveon.selection.border",
  selectedOutlineWidth = "1px",
  as = "article",
  width = "full",
  maxW = "full",
  minW = 0,
  overflow = "hidden",
  bg = "moveon.surface.bg",
  borderWidth = "1",
  borderColor = "moveon.surface.border",
  borderRadius = "md",
  px = DEFAULT_CONTENT_ITEM_CARD_PADDING,
  py = DEFAULT_CONTENT_ITEM_CARD_PADDING,
  boxShadow = "none",
  transition = "border-color 0.2s ease, background-color 0.2s ease",
  children,
  ...rest
}: ContentItemCardProps) {
  const resolvedBg = selected ? selectedBg : bg;
  const resolvedBorderColor = selected ? selectedBorderColor : borderColor;

  return (
    <Box
      as={as}
      width={width}
      maxW={maxW}
      minW={minW}
      overflow={overflow}
      bg={resolvedBg}
      borderWidth={borderWidth}
      borderColor={resolvedBorderColor}
      borderInlineStartWidth={accentColor ? accentWidth : undefined}
      borderInlineStartColor={accentColor}
      borderRadius={borderRadius}
      px={px}
      py={py}
      boxShadow={boxShadow}
      outlineWidth={selected ? selectedOutlineWidth : undefined}
      outlineStyle={selected ? "solid" : undefined}
      outlineColor={selected ? selectedBorderColor : undefined}
      outlineOffset={selected ? "0" : undefined}
      transition={transition}
      data-selected={selected ? "" : undefined}
      {...rest}
    >
      {children}
    </Box>
  );
}
